export default "/images/vendor/flag-icons/flags/1x1/cg.svg?80aa777ee960d381273a4824f70333ff";